import { useEffect } from 'react';
import { useStateSelector } from 'hooks';
import { useDispatch } from 'react-redux';
import { logout as logoutAction } from 'store/settings/actions';

import { PageLoader } from 'components';

const Logout = () => {
  const dispatch = useDispatch();
  const loggingOut = useStateSelector((state) => state.app.loggingOut);

  useEffect(() => {
    dispatch(logoutAction());
  }, []);

  return loggingOut ? <PageLoader /> : null;
};

export default Logout;
